import { type SVGProps } from 'react';

const SvgPlus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={80}
      height={80}
      fill="currentColor"
      viewBox="0 0 80 80"
      role="img"
      aria-labelledby="plus"
      {...props}>
      <title id="plus-icon">plus icon</title>
      <path d="M29.17 48.77a6.195 6.195 0 0 1-.38 8.224l-.535.487-16.847 13.642a6.194 6.194 0 0 1-8.33-9.14l.535-.487 16.846-13.642a6.194 6.194 0 0 1 8.711.916m2.976-28.31a6.194 6.194 0 0 1-9.14 8.33l-.487-.535L8.877 11.408a6.194 6.194 0 0 1 9.14-8.33l.487.535zm38.977 48.132a6.194 6.194 0 0 1-9.14 8.33l-.487-.535-13.642-16.846a6.194 6.194 0 0 1 9.14-8.33l.487.534zm6.18-58.8a6.195 6.195 0 0 1-.38 8.225l-.536.487-16.846 13.642a6.194 6.194 0 0 1-8.33-9.14l.534-.487L68.592 8.877a6.194 6.194 0 0 1 8.711.916" />
    </svg>
  );
};
export default SvgPlus;
